import React, { useEffect, useState } from 'react';
import Title from 'components/UI/Title';
import Button from 'components/UI/Button';
import { connect } from 'react-redux';
import Row from 'components/UI/Layout/Row';
import MemberPhones from 'components/BusinessLogic/MemberPhones';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import PropTypes from 'prop-types';
import Dialog from 'components/UI/Dialog';
import UserInfoForm from 'components/BusinessLogic/UserInfo/UserInfoForm';
import MemberEmails from 'components/BusinessLogic/MemberEmails';

function UserInfo({ authMember })
{
    const [isEditing, setIsEditing] = useState(false);
    const [member, setMember] = useState(false);

    useEffect(() =>
    {
        setMember(authMember);
    }, []);

    const startEditing = () =>
    {
        if (isEditing)
        {
            return;
        }
        setIsEditing(true);
    };

    return (
        <div className="tw-flex tw-flex-col tw-bg-white dark:tw-bg-neutral-900 tw-rounded tw-gap-4 tw-p-3 tw-mb-6 tw-pb-8">
            <Row>
                <Title before title={`${member.prefix ?? ''} ${member.first_name ?? ''} ${member.last_name ?? ''}`} type="primary" padding="tw-pt-0 tw-pl-5" />
                <div className="tw-flex tw-align-middle tw-justify-center">
                    <Button padding="tw-px-3 tw-py-1" onClick={startEditing} margin="tw-mt-3 tw-ml-2" type="primary" className="tw-self-center">
                        Edit
                    </Button>
                    <Dialog
                        model={{ value: isEditing, setter: setIsEditing }}
                    >
                        <UserInfoForm
                            onSuccess={(storedMember) =>
                            {
                                setMember(storedMember);
                                setIsEditing(false);
                            }}
                            onCancel={() =>
                            {
                                setIsEditing(false);
                            }}
                        />
                    </Dialog>
                </div>
            </Row>
            <div className="tw-flex tw-flex-wrap tw-gap-5 tw-ml-8">
                <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Salutation</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.prefix}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">First Name</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.first_name ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Middle Name</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.middle_name ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Last Name</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.last_name ?? '(Empty)'}</p>
                    </div>
                </div>

                <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Best Contact Time</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.best_contact_time}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Job Title</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.job_title ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Mailing Street</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.address ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Mailing ZIP Code</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.zip ?? '(Empty)'}</p>
                    </div>
                </div>

                <div className="tw-flex tw-flex-col tw-pr-5 tw-flex-1 tw-max-w-md tw-gap-5 before:content-[''] before:tw-absolute before:tw-w-[1px] before:tw-h-[100%] before:tw-top-[0%] before:tw-right-0 before:tw-bg-primary-default tw-relative">
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Mailing Country</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.country ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Mailing State</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.state ?? '(Empty)'}</p>
                    </div>
                    <div className="tw-flex tw-flex-col tw-text-xs">
                        <label className="tw-font-bold tw-text-black dark:tw-text-white">Mailing City</label>
                        <p className="tw-text-[#808080] dark:tw-text-[#C9C9C9]">{member.city ?? '(Empty)'}</p>
                    </div>
                </div>
                <Row className="tw-gap-4 max-md:tw-flex-col">
                    <MemberPhones memberId={member.id} className="tw-w-1/2 tw-text-xs max-md:tw-w-full" />

                    <MemberEmails memberId={member.id} className="tw-w-1/2 tw-text-xs max-md:tw-w-full" />
                </Row>
            </div>

        </div>
    );
}

UserInfo.propTypes = {
    authMember: PropTypes.object,
};
const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
    });
};

export default connect(mapStateToProps)(UserInfo);
